import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useErrorHandler } from '../hooks/errorHandler'
import { useSuccessHandler } from '../hooks/successHandler'
import { injectQueryClient } from '../utils/axios/api'

export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
  const errorHandler = useErrorHandler()
  const { addSuccessToast } = useSuccessHandler()

  const memo = useMemo(
    () => {
      const queryClient = new QueryClient({
        defaultOptions: {
          mutations: {
            retry: false,
          },
          queries: {
            retry: false,
            refetchOnWindowFocus: false,
          },
        },
        mutationCache: new MutationCache({
          onSuccess: (_data, _variables, _context, mutation) => {
            if (!mutation.options.meta?.silent) {
              addSuccessToast()
            }
          },
          onError: (error) => errorHandler(error),
        }),
        queryCache: new QueryCache({
          onError: (error) => errorHandler(error),
        }),
      })

      injectQueryClient(queryClient)

      return { queryClient }
    },
    [],
  )

  return <QueryClientProvider client={memo.queryClient}>{children}</QueryClientProvider>
}
